module.exports = __webpack_public_path__ + "img/Monty.df1e293.png";